import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M11.357 2.614a.75.75 0 0 1 .915-.313l3.111 1.212a.75.75 0 0 1 .462.547l.8 3.854 1.262-.158a.75.75 0 0 1 .798.488l2 5.5q.024.066.036.138l1 6.25A.75.75 0 0 1 21 21H3a.75.75 0 0 1-.741-.863l.722-4.757a.75.75 0 0 1 .259-.462L4.81 13.6l.452-2.484A.75.75 0 0 1 6 10.5h.843l.925-4.163a.75.75 0 0 1 .397-.508l1.804-.902zM20.12 19.5l-.85-5.31L17.5 9.317l-3.152.394-1.697 1.698.784.376a.75.75 0 0 1 .401.484l.673 2.541 1.312 1.376a.75.75 0 0 1 .192.368l.6 2.945zm-8.904-8.778L13.47 8.47a.75.75 0 0 1 .437-.214l1.244-.156-.692-3.337-2.142-.834-1.174 1.957a.75.75 0 0 1-.308.285l-1.68.84-.776 3.489h2.204a.75.75 0 0 1 .325.074zm3.865 8.778-.496-2.434-1.296-1.36a.75.75 0 0 1-.182-.325l-.633-2.392L10.413 12H6.626l-.388 2.134a.75.75 0 0 1-.256.44l-1.56 1.31-.55 3.616z"
      clipRule="evenodd"
    />
  </>
);

const Scramble = Icon('scramble', svgContents);

export default Scramble;
